import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const EtapaProyectoService = {
	Listar: (filtro, paginacion) => {
		let params = {
			filtro: {
				area_proyecto: filtro.area_proyecto || null,
				etapa: filtro.etapa || null,
				activo: (Number(filtro.activo) === 1 || Number(filtro.activo) === 0) ? Number(filtro.activo) : 'all',
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Etapa_Proyecto_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_cat_etapa_proyecto: null,
			id_cat_area_proyecto: form.id_cat_area_proyecto || '',
			etapa: form.etapa || '',
			descripcion: form.descripcion || '',
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Etapa_Proyecto_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_etapa_proyecto: form.id_cat_etapa_proyecto,
			id_cat_area_proyecto: form.id_cat_area_proyecto || '',
			etapa: form.etapa || '',
			descripcion: form.descripcion || '',
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Etapa_Proyecto_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_etapa_proyecto) => {
		let params = {
			id_cat_etapa_proyecto: id_cat_etapa_proyecto
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Etapa_Proyecto_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
